var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"map"}},[_c('card',{attrs:{"icon":"map","headline":_vm.$t('visitors.map.headline'),"description":_vm.$t('visitors.map.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }